module.exports = __webpack_public_path__ + "img/Lyruna.2dc67542.png";